import './address-group-info-tooltip.scss';
import React from 'react';
import { observer } from 'mobx-react-lite';
import { useStores } from '../../../store';
import { isNotSaneAddress } from '../../../../utils/versionUtils';

interface InfoTooltipProps {
    displayName: string;
}

export const AddressGroupInfoTooltip: React.FC<InfoTooltipProps> = observer(({ displayName }) => {

    const { fwVersionStore } = useStores();
    const addressGroup = fwVersionStore.getAddressGroups.find(ag => ag.displayName === displayName);
    const addresses = fwVersionStore.getAddresses;
    const addressesAssociatedWithGroup = addressGroup?.addresses.filter(adr => isNotSaneAddress(adr))
        .map(_ => addresses.find(a => a.id === _)?.value);

    return <div className={'info-tooltip'}>
        <div className={'address-group-info'}>
            <div className={'info-ag-header'}>{addressGroup?.displayName}</div>
            <div className={'info-ag-description'}>{addressGroup?.description}</div>
        </div>
        <div className={'addresses-info'}>
            <div className={'info-addresses-header'}>Addresses</div>
            {addressesAssociatedWithGroup?.length ?
                addressesAssociatedWithGroup.map(addressValue => <div className={`info-address-${addressValue}`} key={addressValue}>
                    {addressValue}</div>)
                : 'None'}
        </div>
    </div>;
});